import { render, staticRenderFns } from "./RevenuePerCustomerType.vue?vue&type=template&id=af703a62&scoped=true"
import script from "./RevenuePerCustomerType.vue?vue&type=script&lang=js"
export * from "./RevenuePerCustomerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af703a62",
  null
  
)

export default component.exports